export const getBlurStyles = (blurFields: any[], opacity: number = 50) => {
    if (!blurFields || blurFields.length === 0) return '';

    const shouldBlur = blurFields.some(field => field === true);
    return shouldBlur ? `mix-blend-overlay opacity-${opacity}` : '';
};
